import { Configuration, DefaultApi } from "./api";

const { REACT_APP_API_URL } = process.env;

const configuration: Configuration = new Configuration({
  basePath: REACT_APP_API_URL,
});

export const Api: DefaultApi = new DefaultApi(configuration);
